/* tslint:disable */
import {
  StockLocation,
  Product,
  ProductUom,
  LotConfigurationMpoLine
} from '../index';

declare var Object: any;
export interface ManufacturingProductionOrderLineInterface {
  "id"?: number;
  "in_location_id"?: number;
  "product_id"?: number;
  "product_uom_qty"?: number;
  "product_uom_id"?: number;
  "lot_mpo_lines_ids"?: Array<any>;
  "lot_mpo_lines_values"?: string;
  "total_production_qty_by_shift"?: string;
  inLocation?: StockLocation;
  product?: Product;
  productUom?: ProductUom;
  lotMpoLines?: LotConfigurationMpoLine[];
}

export class ManufacturingProductionOrderLine implements ManufacturingProductionOrderLineInterface {
  "id": number;
  "in_location_id": number;
  "product_id": number;
  "product_uom_qty": number;
  "product_uom_id": number;
  "lot_mpo_lines_ids": Array<any>;
  "lot_mpo_lines_values": string;
  "total_production_qty_by_shift": string;
  inLocation: StockLocation;
  product: Product;
  productUom: ProductUom;
  lotMpoLines: LotConfigurationMpoLine[];
  constructor(data?: ManufacturingProductionOrderLineInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ManufacturingProductionOrderLine`.
   */
  public static getModelName() {
    return "ManufacturingProductionOrderLine";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ManufacturingProductionOrderLine for dynamic purposes.
  **/
  public static factory(data: ManufacturingProductionOrderLineInterface): ManufacturingProductionOrderLine{
    return new ManufacturingProductionOrderLine(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ManufacturingProductionOrderLine',
      plural: 'ManufacturingProductionOrderLines',
      path: 'ManufacturingProductionOrderLines',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
        "in_location_id": {
          name: 'in_location_id',
          type: 'number'
        },
        "product_id": {
          name: 'product_id',
          type: 'number'
        },
        "product_uom_qty": {
          name: 'product_uom_qty',
          type: 'number'
        },
        "product_uom_id": {
          name: 'product_uom_id',
          type: 'number'
        },
        "lot_mpo_lines_ids": {
          name: 'lot_mpo_lines_ids',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        "lot_mpo_lines_values": {
          name: 'lot_mpo_lines_values',
          type: 'string'
        },
        "total_production_qty_by_shift": {
          name: 'total_production_qty_by_shift',
          type: 'string'
        },
      },
      relations: {
        inLocation: {
          name: 'inLocation',
          type: 'StockLocation',
          model: 'StockLocation',
          relationType: 'belongsTo',
                  keyFrom: 'in_location_id',
          keyTo: 'id'
        },
        product: {
          name: 'product',
          type: 'Product',
          model: 'Product',
          relationType: 'belongsTo',
                  keyFrom: 'product_id',
          keyTo: 'id'
        },
        productUom: {
          name: 'productUom',
          type: 'ProductUom',
          model: 'ProductUom',
          relationType: 'belongsTo',
                  keyFrom: 'product_uom_id',
          keyTo: 'id'
        },
        lotMpoLines: {
          name: 'lotMpoLines',
          type: 'LotConfigurationMpoLine[]',
          model: 'LotConfigurationMpoLine',
          relationType: 'referencesMany',
                  keyFrom: 'lot_mpo_lines_ids',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/sdk/models/ManufacturingProductionOrderLine.ts